/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { observer } from "mobx-react";
import { ContactSearchTableContext } from "./ContactSearchTable";
import { formatDiscoverTotalDisplay } from "../DataSearchUtils";

const ContactsFound = () => {
  const { contactData = {} } = useContext(ContactSearchTableContext);

  let totalCount = contactData?.totalContacts || 0;

  const getText = () => {
    const formattedCount = formatDiscoverTotalDisplay(totalCount);
    const label = totalCount === 1 ? "contact" : "contacts";
    return (
      <span className="contactsFoundText">
        <span className="contactsFoundCount">{formattedCount}</span>
        <span className="contactsFoundLabel"> {label}</span>
      </span>
    );
  };

  return totalCount > 0 && <div className="contactsFound">{getText()}</div>;
};

export { ContactsFound };
export default observer(ContactsFound);
